module.exports = __webpack_public_path__ + "static/treasure-d240420234e0a10c12aaab4d360a9f6f.svg";